// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    slackApiContactWebHook:
        'https://hooks.slack.com/services/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',
};



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/environments/environment.ts